import React from 'react';
import { Zap, Sparkles } from 'lucide-react';

export const QuickChipsHeader = () => (
  <header className="qc-hero" data-testid="quick-chips-header">
    <div className="qc-hero-icon"><Zap className="w-8 h-8" fill="currentColor" strokeWidth={1.5} /></div>
    <div className="relative z-10 min-w-0">
      <h1 data-testid="quick-chips-title">Quick Reason Chips</h1>
      <p>Manage quick-select chips for Pending and Clarification actions. Tax, Search and MLS products use separate chip sets.</p>
    </div>
    <div className="qc-hero-deco" aria-hidden="true">
      <Sparkles className="qc-spark qc-spark-1" />
      <Sparkles className="qc-spark qc-spark-2" />
      <Sparkles className="qc-spark qc-spark-3" />
      <span className="qc-deco-chip qc-deco-1">Pending</span>
      <span className="qc-deco-chip qc-deco-2">Clarification</span>
      <span className="qc-deco-chip qc-deco-3">Search</span>
    </div>
  </header>
);
